import { CalendarDays, Clock3, Video, Sparkles, Rocket, ArrowRight } from "lucide-react";
import { PAYMENT_URL, DARK_TEXTURE } from "../lib/site";
import { Reveal, Eyebrow, CtaButton } from "./Reveal";

const DAYS = [
  {
    day: "Day 01",
    date: "25",
    month: "OCT",
    weekday: "Sunday",
    theme: "Create With AI",
    Icon: Sparkles,
    testId: "schedule-day1-card",
  },
  {
    day: "Day 02",
    date: "26",
    month: "OCT",
    weekday: "Monday",
    theme: "Launch & Sell",
    Icon: Rocket,
    testId: "schedule-day2-card",
  },
];

export default function Schedule() {
  return (
    <section id="schedule" data-testid="schedule-section" className="grain relative overflow-hidden bg-[#1C102D] py-20 sm:py-28">
      <img
        src={DARK_TEXTURE}
        alt=""
        aria-hidden="true"
        loading="lazy"
        className="pointer-events-none absolute inset-0 h-full w-full object-cover opacity-[0.08]"
      />
      <div className="drift pointer-events-none absolute -left-32 top-0 h-96 w-96 rounded-full bg-[#7C3AED]/25 blur-[120px]" />
      <div className="drift pointer-events-none absolute -right-32 bottom-0 h-96 w-96 rounded-full bg-[#9B5CF0]/20 blur-[120px]" style={{ animationDelay: "-7s" }} />

      <div className="relative mx-auto max-w-5xl px-5 sm:px-8">
        <div className="mx-auto flex max-w-2xl flex-col items-center gap-5 text-center">
          <Reveal>
            <Eyebrow dark testId="schedule-eyebrow">Live Bootcamp Schedule</Eyebrow>
          </Reveal>
          <Reveal delay={0.08}>
            <h2 data-testid="schedule-title" className="text-3xl font-extrabold leading-[1.12] tracking-tight text-white sm:text-4xl lg:text-[2.75rem]">
              Mark Your Calendar.{" "}
              <span className="bg-gradient-to-r from-[#C9B8F5] to-[#9B5CF0] bg-clip-text text-transparent">
                Your Journey Starts Here.
              </span>
            </h2>
          </Reveal>
          <Reveal delay={0.16}>
            <p className="text-base text-[#B8B1C8] sm:text-lg" data-testid="schedule-subtitle">
              Two Days. Two Live Sessions. One Powerful Learning Experience.
            </p>
          </Reveal>
        </div>

        <div className="mt-14 grid gap-6 sm:grid-cols-2">
          {DAYS.map((d, i) => (
            <Reveal key={d.day} delay={0.15 + i * 0.15}>
              <div
                data-testid={d.testId}
                className="group relative overflow-hidden rounded-3xl border border-white/10 bg-white/[0.06] p-8 backdrop-blur-xl transition-[transform,border-color,box-shadow] duration-300 hover:-translate-y-1.5 hover:border-[#9B5CF0]/50 hover:shadow-[0_30px_60px_-20px_rgba(155,92,240,0.35)] sm:p-10"
              >
                <div className="pointer-events-none absolute -right-16 -top-16 h-48 w-48 rounded-full bg-[#7C3AED]/20 blur-3xl transition-opacity duration-300 group-hover:opacity-100" />
                <div className="relative flex items-start justify-between">
                  <span className="font-mono text-[11px] font-bold uppercase tracking-[0.25em] text-[#9B5CF0]">{d.day}</span>
                  <span className="flex h-11 w-11 items-center justify-center rounded-2xl border border-white/10 bg-white/5 text-[#C9B8F5] transition-colors duration-300 group-hover:border-[#9B5CF0]/40 group-hover:text-white">
                    <d.Icon size={20} />
                  </span>
                </div>
                <div className="relative mt-6 flex items-end gap-3">
                  <span className="text-6xl font-extrabold leading-none tracking-tight text-white sm:text-7xl">{d.date}</span>
                  <span className="pb-1.5">
                    <span className="block font-mono text-sm font-bold tracking-[0.3em] text-[#9B5CF0]">{d.month}</span>
                    <span className="mt-1 block text-sm font-semibold uppercase tracking-widest text-[#B8B1C8]">{d.weekday}</span>
                  </span>
                </div>
                <div className="relative mt-7 space-y-3 border-t border-white/10 pt-6">
                  <div className="flex items-center gap-2.5 text-sm font-semibold text-white">
                    <Clock3 size={16} className="text-[#9B5CF0]" />
                    8:00 PM IST
                  </div>
                  <div className="flex items-center gap-2.5 text-sm font-semibold text-white">
                    <Video size={16} className="text-[#9B5CF0]" />
                    Live Online
                  </div>
                  <div className="flex items-center gap-2.5 text-sm font-semibold text-[#C9B8F5]">
                    <CalendarDays size={16} className="text-[#9B5CF0]" />
                    {d.theme}
                  </div>
                </div>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.4} className="mt-12 text-center">
          <CtaButton href={PAYMENT_URL} testId="schedule-cta" dark>
            Reserve My Seat — ₹199 <ArrowRight size={17} strokeWidth={2.5} />
          </CtaButton>
          <p className="mt-4 text-xs font-medium text-[#B8B1C8]">One-Time Registration • 25–26 October 2026 • 8:00 PM IST</p>
        </Reveal>
      </div>
    </section>
  );
}
